import { createEvent } from "ics"

interface EventAttributes {
  title: string
  description: string
  startDate: Date
  endDate: Date
  url: string
}

export function createCalendarEvent(eventAttributes: EventAttributes) {
  return new Promise<string>((resolve, reject) =>
    createEvent(
      {
        title: eventAttributes.title,
        description: eventAttributes.description,
        start: [
          eventAttributes.startDate.getFullYear(),
          eventAttributes.startDate.getMonth() + 1,
          eventAttributes.startDate.getDate(),
          eventAttributes.startDate.getHours(),
          eventAttributes.startDate.getMinutes(),
        ],
        end: [
          eventAttributes.endDate.getFullYear(),
          eventAttributes.endDate.getMonth() + 1,
          eventAttributes.endDate.getDate(),
          eventAttributes.endDate.getHours(),
          eventAttributes.endDate.getMinutes(),
        ],
        url: eventAttributes.url,
      },
      (error, value) => {
        if (error) {
          reject(error)
        }
        resolve(value)
      },
    ),
  )
}
